<template>
  <div class="member-integral">
    <el-tabs class="el-tabs-common" v-model="tab" @tab-click="onClickTab">
      <el-tab-pane
        v-for="(item, key) in tabs"
        :key="key"
        :label="item.title"
        :name="item.key"
      ></el-tab-pane>
    </el-tabs>
    <div class="tab-content" :class="'tab-content-' + tab">
      <MemberIntegralSurvey v-if="tab == 'survey'" @changeTab="changeTab"></MemberIntegralSurvey>
      <MemberIntegralDetail v-else-if="tab == 'detail'"></MemberIntegralDetail>
      <MemberIntegralRecord v-else-if="tab == 'record'"></MemberIntegralRecord>
    </div>
  </div>
</template>
<script>
import MemberIntegralSurvey from './MemberIntegralSurvey';
import MemberIntegralDetail from './MemberIntegralDetail';
import MemberIntegralRecord from './MemberIntegralRecord';
export default {
  name: 'MemberIntegral',
  components: {
    MemberIntegralSurvey,
    MemberIntegralDetail,
    MemberIntegralRecord,
  },
  data() {
    return {
      tab: 'survey',
      type: 'good',
    };
  },
  computed: {
    tabs() {
      return [
        {
          key: 'survey',
          title: `${this.$store.state.commonSetting.point_info.point_name || '积分'}概况`,
        },
        {
          key: 'detail',
          title: `${this.$store.state.commonSetting.point_info.point_name || '积分'}明细`,
        },
        {
          key: 'record',
          title: '兑换记录',
        },
      ];
    },
  },
  methods: {
    changeTab(tab, type) {
      this.tab = tab;
      this.type = type;
    },
    onClickTab() {
      if (this.tab != 'store') {
        this.type = 'good';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.member-integral {
  background: #fff;
  border-radius: 8px;
  .el-tabs {
    padding: 0 24px;
  }
}
.tab-content {
  padding: 0 25px;
}

.tab-content-store {
  padding: 0;
}
</style>
